import React from 'react'
import Button, { ButtonProps } from 'shared/components/Button'

import { buildMyIdOAuthStringACME } from 'auth/buildMyIdOAuthString'

type Props = ButtonProps & {
    returnTo?: string
}
const LoginButton: React.FC<Props> = ({ returnTo, ...props }): React.ReactElement => {
    const [submitting, setSubmitting] = React.useState(false)

    const handleClick = React.useCallback(() => {
        setSubmitting(true)
        // redirect to MyID OAuth
        const loginURL = buildMyIdOAuthStringACME(returnTo)
        window.location.assign(loginURL)
    }, [returnTo])

    return (
        <Button
            {...props}
            size={'large'}
            disabled={submitting}
            isLoading={submitting}
            onClick={handleClick}
        >
            Log in
        </Button>
    )
}

export default LoginButton
